/**
 * Core primitive types used throughout Kantera.
 * These branded types provide compile-time type safety while maintaining runtime ergonomics.
 */
/**
 * Helper to create a branded UUID at compile time.
 * Runtime: Use UUID generation library; this is purely for type assertions.
 */
export const brandUUID = (id) => id;
export const brandOrgId = (id) => id;
export const brandUserId = (id) => id;
export const brandTimestamp = (ts) => ts;
//# sourceMappingURL=common.js.map